import { render, staticRenderFns } from "./Block3.vue?vue&type=template&id=0c0b8403&scoped=true&"
import script from "./Block3.vue?vue&type=script&lang=js&"
export * from "./Block3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0b8403",
  null
  
)

export default component.exports